import styled from "styled-components";
import { PrimaryButton } from "components/Button/style";

export const FiltroContainer = styled.div`
  margin-top: 0.5rem;
  margin-bottom: 1rem;
  padding: 20px;
  border-radius: 8px;
  background-color: ${({ theme }) => theme.colors.neutral.neutral05};

  .row {
    row-gap: 12px;
  }

  .filtro-col {
    display: grid;
    grid-template-columns: minmax(0, 1fr);
    min-width: 0;
  }
`;

export const AcoesContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 8px;
  padding-top: 1.7rem;
  white-space: nowrap;
`;

export const Button = styled(PrimaryButton)`
  width: 90px;
`;

export const BuscaContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-bottom: 0.5rem;

  > div {
    width: 260px;
    max-width: 100%;
  }
`;

export const TabelaContainer = styled.div`
  flex: 1;
  min-height: 220px;
  overflow: hidden;
`;

export const ContadorSelecionados = styled.p`
  margin-bottom: 8px;
`;
